// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetAuditResultModal = () => ({
    type: actions.RESET_AUDIT_SUMMARY_REPORT_AUDIT_RESULT_MODAL
});

export const updateAuditResultModal = (property, value) => ({
    property,
    type: actions.UPDATE_AUDIT_SUMMARY_REPORT_AUDIT_RESULT_MODAL,
    value
});



// WEBPACK FOOTER //
// ./src/reports/audit-summary/action-creators/audit-result-modal.js